// extracted by mini-css-extract-plugin
export default {"page":"Fs4zo","content":"ljfhw","image":"_6hwrN","info":"LvB9A","callCenter":"PKTw0","footer":"ZPolW"};